/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBvbHlnb24gcG9pbnRzPSI2LjA3IDEyLjg1IDAuOTUgNy43MyAxLjY1IDcuMDIgNi4wNyAxMS40MyAxNC4zNSAzLjE1IDE1LjA1IDMuODYgNi4wNyAxMi44NSIvPjwvc3ZnPg==";